import React, { useContext, useEffect, useState } from 'react';
import AddAddress from '../Modal/addAdress';
import axios from 'axios';
import { users_uri } from '../../uri';
import { AuthContext } from '../../context/auth';
import { Alert } from '@chakra-ui/react';

const AddressPage = () => {
    const [data, setData] = useState([]);
    const [address, setAddress] = useState([]);
    const {currentUser} = useContext(AuthContext);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        Get();
      }, []);
    
      const Get = async () => {
        try{
          const res = await axios.get(users_uri+`/address/get?token=${currentUser}`);
          setAddress(res.data);
          setLoad(false);
        }catch(err){
          console.log(err);
          Alert.alert('Алдаа', 'Түр хүлээгээд дахин оролдоно уу !');
          setLoad(false);
        }
      }

    const callback = () => {
        Get();
    }
  return (
    <div>
        <div className='md:mx-20 xs:mx-2 mt-2'>
            
            <AddAddress callback={callback}/>
            <div className='bg-white/40 p-4 rounded-xl mt-4 font-Roboto'>
                {
                    address.map((it, index) => {
                        return(
                            <div key={index} className='bg-white rounded-xl p-4 mt-1'>
                                <div className='flex gap-6'>
                                    <div>
                                        <h1 className='text-gray-500 text-sm'>Аймаг / Хот</h1>
                                        <p className='uppercase text-sm font-bold'>{it.city}</p>
                                    </div>
                                    <div>
                                        <h1 className='text-gray-500 text-sm'>Сум / Дүүрэг</h1>
                                        <p className='uppercase text-sm font-bold'>{it.district}</p>
                                    </div>
                                </div>
                                <div className='mt-2'>
                                    <h1 className='text-gray-500 text-sm'>Баг / Хороо</h1>
                                    <p className='uppercase text-sm font-bold'>{it.khoroo}</p>
                                </div>
                                <div className='mt-2'>
                                    <h1 className='text-gray-500 text-sm'>Хаяг</h1>
                                    <p className='uppercase text-sm font-bold'>{it.address}</p>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    address.length === 0 &&
                    <div className=' flex items-center justify-center flex-col mt-6'>
                        <img className='h-24' src='../../icons/empty-box.png'/>
                        <h1 className='mt-2 text-center'>Хоосон байна</h1>
                    </div>
                }
            </div>
        </div>
    </div>
  )
}

export default AddressPage